import { redirectToStore } from '../utils/deviceDetection'
import { QRCodeSVG } from 'qrcode.react'
import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import '../styles/Hero.css'

function Hero() {
  const appStoreLink = 'https://apps.apple.com/app/breakout/id6739900411'
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' }
  ]

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setIsScrolled(scrollY > 20)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <section className="hero" role="banner">
      {/* Mobile Header Bar */}
      <div className={`mobile-header ${isScrolled ? 'scrolled' : ''}`}>
        <img 
          src="/assets/splash-icon.png" 
          alt="Breakout App Icon" 
          className="mobile-header-icon"
          loading="eager"
        />
        <h1 className="mobile-header-title">Breakout</h1>
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      <div className="hero-content">
        <header className="hero-text">
          {/* Main Brand Header - Hidden on mobile */}
          <div className="hero-brand">
            <img 
              src="/assets/splash-icon.png" 
              alt="Breakout Dating App Logo" 
              className="hero-icon"
              loading="eager"
            />
            <h1 className="brand-name">Breakout</h1>
          </div>
          
          {/* Main Headline */}
          <div className="hero-headlines">
            <h2 className="hero-title">Activity-Based Dating</h2>
            <p className="hero-tagline">Connect Through What You Do</p>
          </div>
          
          {/* Description */}
          <div className="hero-description-wrapper">
            <p className="hero-description">
              Build your profile based on your passions. Join activities, discover experiences, 
              and meet people who share your interests. The revolutionary dating app that goes 
              beyond swiping to create meaningful connections through shared activities and hobbies.
            </p>
          </div>
          
          {/* Download CTA */}
          <div className="hero-cta" role="region" aria-label="Download Options">
            <div className="cta-qr" role="img" aria-label="QR Code to download Breakout app">
              <div className="qr-code">
                <QRCodeSVG 
                  value={appStoreLink} 
                  size={200}
                  level="H"
                  includeMargin={false}
                  title="Scan to download Breakout app"
                />
              </div>
              <p className="qr-label">Scan to download</p>
            </div>
            
            <div className="cta-divider" aria-hidden="true">
              <span>or</span>
            </div>
            
            <div className="cta-primary">
              <button 
                className="app-store-button"
                onClick={() => redirectToStore('ios')}
                aria-label="Download Breakout on the App Store"
                type="button"
              >
                <span className="button-text">Download on the App Store</span>
              </button>
              <p className="platform-text">Available on iOS • Android coming soon</p>
            </div>
          </div>
        </header>
        
        <div className="hero-visual" aria-hidden="true">
          <div className="phone-frame">
            <div className="phone-screen">
              <img 
                src="/assets/splash-icon.png" 
                alt="" 
                className="screen-icon"
                loading="lazy"
              />
              <span className="screen-text">Breakout</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
